module.exports = require("@pb/kit-util-scroll-into-view");